import { useCustomGetProposalPackageSummaryQuery } from "generated/graphql";
import { useEffect } from "react";

export default function useProposalPackageSummary(id?: string, skip = false) {
  const query = useCustomGetProposalPackageSummaryQuery({
    variables: { id },
    skip: skip || !id,
    fetchPolicy: "network-only",
  });

  const isSending = ["QUEUED", "PROCESSING"].includes(
    query.data?.getProposal?.latestPackageSendRun?.status ?? ""
  );

  useEffect(() => {
    if (isSending) {
      query.startPolling(3000);
      return query.stopPolling;
    }

    query.stopPolling();
  }, [isSending, query.startPolling, query.stopPolling]);

  return query;
}
